import React from 'react';
import './style.scss';

interface ComponentProps {
  center: React.ReactNodeArray;
}

interface GridProps {
  components: ComponentProps;
}
const OneColumn: React.FC<GridProps> = ({ components }) => {
  const { center } = components;
  return <div styleName="gridone">{center}</div>;
};
export default OneColumn;
